import React from "react";
import { resolveAssetPath } from "../utils/content";
import "./Preloader.css";

const logoSrc = resolveAssetPath("/assets/brand/Untitlsed-1.png");
const logoMaskStyle = {
  WebkitMaskImage: `url(${logoSrc})`,
  maskImage: `url(${logoSrc})`
};

const Preloader = ({ visible }) => {
  return (
    <div
      className={`preloader ${visible ? "is-visible" : "is-hidden"}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="preloader-content">
        <div className="preloader-logo-shell" aria-label="Loading logo">
          <span className="preloader-logo-core" style={logoMaskStyle} />
          <span className="preloader-logo-edge" style={logoMaskStyle} />
          <span className="preloader-logo-sweep" style={logoMaskStyle} />
        </div>
      </div>
    </div>
  );
};

export default React.memo(Preloader);
